import script from "./HeaderSubMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderSubMenu.vue?vue&type=script&setup=true&lang=js"

import "./HeaderSubMenu.vue?vue&type=style&index=0&id=0072b0ed&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0072b0ed"]])

export default __exports__